import React from "react";
import Profile from "~/components/layout/Profile";
import { LayoutBreadcrumbs } from "./Layout";
// Assuming shadcn Button path
// Import Input if you add the search bar: import { Input } from "@/components/ui/input";

const Header = ({ children }: { children?: React.ReactNode }) => {
  // Get current date for potential use, though not directly in this static layout
  // Example: YYYY-MM-DD format for Canada

  return (
    <div className="h-[55px] bg-gray-850 text-gray-300 flex items-center w-full justify-between px-6 border-b border-gray-300 flex-shrink-0">
      {/* Left Side - Breadcrumbs / Context */}
      <LayoutBreadcrumbs>{children}</LayoutBreadcrumbs>

      {/* Right Side - Actions */}
      <div className="flex items-center space-x-3 sm:space-x-4 flex-shrink-0">
        {/* Optional Search Input - Uncomment and style if needed */}
        {/*
        <div className="hidden md:block"> // Hide on small screens
          <Input
            type="search"
            placeholder="Search..."
            className="bg-gray-700 border-gray-600 h-8 text-sm w-40 lg:w-64"
          />
        </div>
         */}
        <Profile />
      </div>
    </div>
  );
};

export default Header;
